import React from 'react';
import LayoutNoLogin from '../../components/layout/LayoutNoLogin';

const Impressum = () => {
    return (
        <LayoutNoLogin>
            <div className="p-6 max-w-3xl mx-auto">
                <h2 className="text-2xl font-bold mb-4">Impressum</h2>


                <h3 className="text-xl font-semibold mb-2">Anbieter:</h3>

                <p className="mb-4">
                    <strong>Julian Blöchl</strong><br />
                    Keferloherstraße 45<br />
                    80809 München<br />
                    Deutschland
                </p>

                <h3 className="text-xl font-semibold mb-2">Kontakt</h3>
                <p className="mb-4">
                    Telefon: <a href="tel:+49 173 665 2274" className="text-blue-500 hover:underline">+49 173 665227 4</a><br />
                    E-Mail: <a href="mailto:julian.m.bloechl@gmail.com" className="text-blue-500 hover:underline">julian.m.bloechl@gmail.com</a>
                </p>

                <h3 className="text-xl font-semibold mb-2">Verantwortlich für den Inhalt:</h3>
                <p className="mb-4">
                    <strong>Julian Blöchl</strong><br />
                    Keferloherstraße 45<br />
                    80809 München<br />
                    Deutschland
                </p>

                <h3 className="text-xl font-semibold mb-2">Haftungsausschluss</h3>
                <p className="mb-4">
                    Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>

                <h3 className="text-xl font-semibold mb-2">Quellenangaben</h3>
                <p className="mb-4">
                    Alle Fragen und Antworten in der App wurden von der offiziellen Webseite <a href="https://www.elwis.de" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">www.elwis.de</a> übernommen.
                </p>

                <h3 className="text-xl font-semibold mb-2">Urheberrecht</h3>
                <p className="mb-4">
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
            </div>
        </LayoutNoLogin>
    );
};

export default Impressum;
